import { render, staticRenderFns } from "./FulfillmentEdit.vue?vue&type=template&id=78fa69a8&scoped=true&"
import script from "./FulfillmentEdit.vue?vue&type=script&lang=js&"
export * from "./FulfillmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa69a8",
  null
  
)

export default component.exports